import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_PublishedSientificResearch = createAsyncThunk(
  "SU_NT_MRI_PublishedSientificResearch/GetOneSU_NT_MRI_PublishedSientificResearch",
  async (publishedSientificResearchId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_PublishedSientificResearch/GetOneSU_NT_MRI_PublishedSientificResearch",
        {
          publishedSientificResearchId: publishedSientificResearchId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteOtherSupportingParties = createAsyncThunk(
  "DeleteOtherSupportingParties/DeleteOtherSupportingParties",
  async (otherSupportingPartiesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/DeleteOtherSupportingParties",
        {
          otherSupportingPartiesId: otherSupportingPartiesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSU_NT_MRI_PublishedSientificResearch = createAsyncThunk(
  "SU_NT_MRI_PublishedSientificResearch/DeleteSU_NT_MRI_PublishedSientificResearch",
  async (publishedSientificResearchId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_PublishedSientificResearch/DeleteSU_NT_MRI_PublishedSientificResearch",
        {
          publishedSientificResearchId: publishedSientificResearchId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateSU_NT_MRI_PublishedSientific = createAsyncThunk(
  "SU_NT_MRI_PublishedSientificResearch/UpdateSU_NT_MRI_PublishedSientific",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_PublishedSientificResearch/UpdateSU_NT_MRI_PublishedSientific",
        {
          publishedSientificResearchId: model.publishedSientificResearchId,
          reference: model.reference,
          link: model.link,
          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSU_NT_MRI_PublishedSientific = createAsyncThunk(
  "SU_NT_MRI_PublishedSientificResearch/AddSU_NT_MRI_PublishedSientific",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_PublishedSientificResearch/AddSU_NT_MRI_PublishedSientific",
        {
          reference: model.reference,
          link: model.link,
          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublishedScientificRes = createSlice({
  name: "PublishedScientificRes",
  initialState: {
    publishedSientificResearch: {},
    loadingpublishedSientificResearch: false,
    errorpublishedSientificResearch: null,

    AddpublishedSientificResearch: {},
    loadingAddpublishedSientificResearch: false,
    errorAddpublishedSientificResearch: null,

    UpdatepublishedSientificResearch: {},
    loadingUpdatepublishedSientificResearch: false,
    errorUpdatepublishedSientificResearch: null,

    DeletepublishedSientificResearch: {},
    loadingDeletepublishedSientificResearch: false,
    errorDeletepublishedSientificResearch: null,

    ListpublishedSientificResearch: {},
    loadingListpublishedSientificResearch: false,
    errorListpublishedSientificResearch: null,
  },
  reducers: {
    restValidateOtherSupportingParties: (state, action) => {
      state.OtherSupportingPartiesValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneSU_NT_MRI_PublishedSientificResearch.pending,
        (state, action) => {
          state.loadingpublishedSientificResearch = true;
          state.publishedSientificResearch = action.payload;
          state.errorpublishedSientificResearch = null;
        }
      )
      .addCase(
        GetOneSU_NT_MRI_PublishedSientificResearch.fulfilled,
        (state, action) => {
          state.loadingpublishedSientificResearch = false;
          state.publishedSientificResearch = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneSU_NT_MRI_PublishedSientificResearch.rejected,
        (state, action) => {
          state.loadingpublishedSientificResearch = false;
          state.errorpublishedSientificResearch = action.payload;
        }
      )

      .addCase(
        DeleteSU_NT_MRI_PublishedSientificResearch.pending,
        (state, action) => {
          state.loadingDeletepublishedSientificResearch = true;
          state.DeletepublishedSientificResearch = action.payload;
          state.errorDeletepublishedSientificResearch = null;
        }
      )
      .addCase(
        DeleteSU_NT_MRI_PublishedSientificResearch.fulfilled,
        (state, action) => {
          state.loadingDeletepublishedSientificResearch = false;
          state.DeletepublishedSientificResearch = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteSU_NT_MRI_PublishedSientificResearch.rejected,
        (state, action) => {
          state.loadingDeletepublishedSientificResearch = false;
          state.errorDeletepublishedSientificResearch = action.payload;
        }
      )

      .addCase(UpdateSU_NT_MRI_PublishedSientific.pending, (state, action) => {
        state.loadingUpdatepublishedSientificResearch = true;
        state.UpdatepublishedSientificResearch = action.payload;
        state.errorUpdatepublishedSientificResearch = null;
      })
      .addCase(
        UpdateSU_NT_MRI_PublishedSientific.fulfilled,
        (state, action) => {
          state.loadingUpdatepublishedSientificResearch = false;
          state.UpdatepublishedSientificResearch = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateSU_NT_MRI_PublishedSientific.rejected, (state, action) => {
        state.loadingUpdatepublishedSientificResearch = false;
        state.errorUpdatepublishedSientificResearch = action.payload;
      })

      .addCase(AddSU_NT_MRI_PublishedSientific.pending, (state, action) => {
        state.loadingAddpublishedSientificResearch = true;
        state.AddpublishedSientificResearch = action.payload;
        state.errorAddpublishedSientificResearch = null;
      })
      .addCase(AddSU_NT_MRI_PublishedSientific.fulfilled, (state, action) => {
        state.loadingAddpublishedSientificResearch = false;
        state.AddpublishedSientificResearch = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSU_NT_MRI_PublishedSientific.rejected, (state, action) => {
        state.loadingAddpublishedSientificResearch = false;
        state.errorAddpublishedSientificResearch = action.payload;
      });
  },
});
export const { restValidateOtherSupportingParties } =
  PublishedScientificRes.actions;
export default PublishedScientificRes.reducer;
